import { createTheme, ThemeProvider } from '@mui/material/styles';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './main.css';
import { Certificate } from './pages/Certificate';
import Root from './root';
import { themeConfig } from './utils/theme';
import './i18n';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LoadingProvider } from '@pok/weblib/context/loading-context.jsx';
import TagManager from 'react-gtm-module';
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

const newrelic = JSON.parse(import.meta.env.VITE_NEWRELIC_VIEWER);
new BrowserAgent(newrelic);

const theme = createTheme(themeConfig);

const CertificateNotFound = React.lazy(() => import('./pages/CertificateNotFound.jsx'));
const AcceptCertificate = React.lazy(() => import('./pages/AcceptCertificate.jsx'));
const Certificates = React.lazy(() => import('./pages/Certificates.jsx'));

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});

TagManager.initialize({
    gtmId: 'GTM-5LTF29X3',
    auth: import.meta.env.VITE_GTM_AUTH,
    preview: import.meta.env.VITE_GTM_PREVIEW,
});

const router = createBrowserRouter([
    {
        path: '/',
        element: <Root />,
        errorElement: <CertificateNotFound />,
        children: [
            {
                path: 'certificate/:certificateId',
                element: <Certificate />,
            },
            {
                path: 'c/:certificateId',
                element: <Certificate />,
            },
            {
                path: 'l/:userId/public',
                element: <Certificates />,
            },
            {
                path: 'linkedin',
                element: <Certificate />,
            },
            {
                path: 'accept/:id/:token/:otc/:defaultCode',
                element: <AcceptCertificate />,
            },
            {
                path: 'accept/:id/:token',
                element: <AcceptCertificate />,
            },
            {
                path: '*',
                element: <CertificateNotFound />,
            },
        ],
    },
]);

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={theme}>
                <LoadingProvider>
                    <Suspense>
                        <RouterProvider router={router} />
                    </Suspense>
                </LoadingProvider>
            </ThemeProvider>
        </QueryClientProvider>
    </React.StrictMode>,
);
